export const app = {
  title: '3D Configurator',
}
